import type { IProductionStatementCreationJob } from "@/interfaces/api/production-statement-creation-job.interface"
import { ProductionStatementCreationJobStatuses } from "@/enums/models/production-statement-creation-job-statuses"
import { BaseModel } from "@/models/base.model"
import type { Moment } from "moment"
import { Project } from "@/models/project.model.ts"
import { ModelFactory } from "@/factories/model-factory.ts"

export class ProductionStatementCreationJob
  extends BaseModel
  implements IProductionStatementCreationJob
{
  public static className = "ProductionStatementCreationJob"

  public static override managedResolveFields = ["project"]

  productionStatement: string
  project: Project
  status: ProductionStatementCreationJobStatuses
  periodStart: Moment
  periodEnd: Moment

  // Annotated fields
  salesSum: string
  rentalDispenseMaterializationsSum: string

  constructor(job: IProductionStatementCreationJob, managed = false) {
    super(job)

    this.productionStatement = job.productionStatement
    this.project = ModelFactory.childModel(Project, job.project, managed)
    this.status = job.status
    this.periodStart = job.periodStart
    this.periodEnd = job.periodEnd

    this.salesSum = job.salesSum ?? "0"
    this.rentalDispenseMaterializationsSum = job.rentalDispenseMaterializationsSum ?? "0"
  }

  /** The total sum of sales and rental dispense materializations reserved by the job. */
  public get sum() {
    return parseFloat(this.salesSum) + parseFloat(this.rentalDispenseMaterializationsSum)
  }

  /** The ISO week numbers of the job's period. */
  public get displayPeriodISOWeek(): string {
    const startWeek = this.periodStart?.isoWeek()
    const endWeek = this.periodEnd?.isoWeek()

    if (startWeek === undefined) return endWeek === undefined ? "" : `WK ${endWeek}`
    if (endWeek === undefined || endWeek === startWeek) return `WK ${startWeek}`

    return `WK ${startWeek} t/m WK ${endWeek}`
  }
}
